export const MSP = "msp";
export const CUSTOMER = "customer";
